import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return (
    <input
      className={cn(
        'border border-line-bold bg-surface-strong px-3 py-2 text-sm',
        'focus:outline-2 focus:outline-offset-0 focus:outline-brand-700',
        'disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

/** 数値入力。桁を読みやすくするため等幅で組む。 */
export function NumberInput({ className, ...props }: ComponentProps<'input'>) {
  return <Input type="number" className={cn('font-mono', className)} {...props} />;
}
